export default "/dist/files/icon_programme.333d467e1e336e92bc3a6ff234a930eb.svg";